import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65288071"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "theme-bar__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_CalculatorButton = _resolveComponent("CalculatorButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CalculatorButton, {
      class: "theme-bar__button",
      href: "https://github.com/Tito-Kati/Calculator",
      target: "_blank",
      key: "github",
      variant: "clear"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FontAwesomeIcon, {
          icon: _ctx.faGithub,
          "fixed-width": ""
        }, null, 8, ["icon"])
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.themes, (theme) => {
      return (_openBlock(), _createBlock(_component_CalculatorButton, {
        class: "theme-bar__button",
        onClick: ($event: any) => (_ctx.themeSwitcher.setTheme(theme)),
        key: theme,
        variant: "number"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FontAwesomeIcon, {
            icon: _ctx.iconFor(theme),
            "fixed-width": ""
          }, null, 8, ["icon"])
        ]),
        _: 2
      }, 1032, ["onClick"]))
    }), 128))
  ]))
}